import Image from 'next/image';
import { memo, useEffect, useRef, useState } from 'react';

import Loading from '@/components/common/Loading';

import ControllerBar from '../../preview/components/ControllerBar';
import { player } from '../../utils/playerClass';
const UploadAudioSuccess: React.FC<{
  url: string;
  name: string;
}> = ({ url, name }) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (audioRef.current) {
      player.setMediaElement(audioRef.current);

      // 添加加载完成的监听
      const handleCanPlay = () => {
        setLoading(false);
      };

      audioRef.current.addEventListener('canplay', handleCanPlay);

      return () => {
        audioRef.current?.removeEventListener('canplay', handleCanPlay);
        player.destroy();
      };
    }
  }, []);

  return (
    <div className="h-[304px] w-full flex flex-col items-center  pt-[60px]">
      {loading && <Loading />}
      {/* <div>
        <Image src="/images/musicIcon.png" width={120} height={120} alt="" />
      </div> */}
      <span className="text-[18px] font-medium leading-[22px] tracking-[0.58px] ">
        {name || ''}
      </span>
      <audio ref={audioRef} className="hidden" />
      <div className="w-full px-[12px] pt-[52px]">
        <ControllerBar url={url} />
      </div>
    </div>
  );
};
const MemoAudioSuccess = memo(UploadAudioSuccess);
export default MemoAudioSuccess;
